module.exports = __webpack_public_path__ + "static/media/bannerPlaceholder.0901176f.png";